const SearchCMS = {
    searchInputPlaceholder: "search.searchInputPlaceholder",
    emptySearchInputHeadline: "search.emptySearchInputHeadline",
    noResultsSearchText: "search.noResultsSearchText",
    noResultsSearchTextQuery: "search.noResultsSearchTextQuery",
    searchInputWithQueryHeadline: "search.searchInputWithQueryHeadline",
    paginationResults: "search.paginationResults",
    showMoreButton: "search.showMoreButton",
};

export default SearchCMS;
